import { render, staticRenderFns } from "./calendar-add.vue?vue&type=template&id=f08ef27c&"
import script from "./calendar-add.vue?vue&type=script&lang=js&"
export * from "./calendar-add.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f08ef27c')) {
      api.createRecord('f08ef27c', component.options)
    } else {
      api.reload('f08ef27c', component.options)
    }
    module.hot.accept("./calendar-add.vue?vue&type=template&id=f08ef27c&", function () {
      api.rerender('f08ef27c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/svg/calendar-add.vue"
export default component.exports